import Settings from '../settings/ConfigServer';
import storageUtils from "../helpers/tokenUtils";

const GET_INVOICES_API_URL = `${Settings.urlLocal}/invoices`;
const GET_INVOICES_BY_DATE_API_URL = `${Settings.urlLocal}/invoices/getdate`
const GET_INVOICES_BY_DATE_ALL_API_URL = `${Settings.urlLocal}/invoices/getalldate`
const GET_INVOICE_REFERENCE_DETAILS_API_URL = `${Settings.urlLocal}/invoices/get-invoice-reference-details`
const CREATE_INVOICE_API_URL = `${Settings.urlLocal}/invoices/create`;
const UPDATE_INVOICE_API_URL = `${Settings.urlLocal}/invoices/update`;
const REMOVE_INVOICE_API_URL = `${Settings.urlLocal}/invoices/delete`;
const UPDATE_INVOICE_WEIGHT_API_URL = `${Settings.urlLocal}/invoices/update-weight`;

const InvoiceService = {}

InvoiceService.getInvoicesPaginated = async (params = {}, signal) => {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            searchParams.append(key, value);
        }
    });
    const queryString = searchParams.toString();
    const url = queryString
        ? `${GET_INVOICES_API_URL}?${queryString}`
        : GET_INVOICES_API_URL;

    const response = await fetch(url, {
        headers: {
            'Authorization': `Bearer ${storageUtils.getToken()}`
        },
        signal
    });
    if (!response.ok) {
        const errorBody = await response.json().catch(() => ({}));
        throw new Error(errorBody.message || 'Something went wrong!, please try again');
    }
    const data = await response.json();
    const payload = data.response;

    // Normalize response shape:
    //   - New paginated contract: { data: [...], pagination: { total, page, limit, totalPages } }
    //   - Legacy contract (backend not deployed yet): [ ...invoices ]
    if (Array.isArray(payload)) {
        return {
            data: payload,
            pagination: {
                page: 1,
                limit: payload.length,
                total: payload.length,
                totalPages: 1,
            },
        };
    }
    return {
        data: Array.isArray(payload?.data) ? payload.data : [],
        pagination: {
            page: payload?.pagination?.page ?? 1,
            limit: payload?.pagination?.limit ?? 0,
            total: payload?.pagination?.total ?? 0,
            totalPages: payload?.pagination?.totalPages ?? 0,
        },
    };
}

InvoiceService.getInvoice = async invoiceId => {
    const response = await fetch(`${GET_INVOICES_API_URL}/${invoiceId}`, {
        headers: {
            'Authorization': `Bearer ${storageUtils.getToken()}`
        }
    });
    if (!response.ok) {
        throw new Error('Something went wrong!, please try again');
    }
    const data = await response.json();

    return data.response;
}

InvoiceService.getInvoicesByDate = async(dateTo, dateFrom) => {
    const response = await fetch(`${GET_INVOICES_BY_DATE_API_URL}?dateTo=${dateTo}&dateFrom=${dateFrom}`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${storageUtils.getToken()}`
        }
    });
    if (!response.ok) {
        throw new Error('Something went wrong!, please try again');
    }
    const data = await response.json();

    return data.response.map(reference => {
        return reference
    });
}

InvoiceService.getInvoicesByDateAll = async(dateTo, dateFrom) => {
    const response = await fetch(`${GET_INVOICES_BY_DATE_ALL_API_URL}?dateTo=${dateTo}&dateFrom=${dateFrom}`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${storageUtils.getToken()}`
        }
    });
    if (!response.ok) {
        throw new Error('Something went wrong!, please try again');
    }
    const data = await response.json();

    return data.response.map(reference => {
        return reference
    });
}

InvoiceService.getDeatlsInvoiceReferences = async (invoiceId) => {
    const response = await fetch(`${GET_INVOICE_REFERENCE_DETAILS_API_URL}/${invoiceId}`,{
        headers: {
            'Authorization': `Bearer ${storageUtils.getToken()}`
        }
    })
    if (!response.ok) {
        throw new Error('Something went wrong!, please try again');
    }
    const data = await response.json();

    return data.response.map(reference => {
        return reference
    });
}

InvoiceService.createInvoice = async invoice => {
    const response = await fetch(CREATE_INVOICE_API_URL, {
        method: 'POST',
        body: JSON.stringify(invoice),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${storageUtils.getToken()}`
        }
    })
    
    if (!response.ok) {
        throw new Error('Something went wrong!, please try again');
    }

    return response;
}

InvoiceService.updateInvoice = async invoice => {
    const response = await fetch(`${UPDATE_INVOICE_API_URL}/${invoice.id}`, {
        method: 'PUT',
        body: JSON.stringify(invoice),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${storageUtils.getToken()}`,
            'role': storageUtils.getRole()
        }
    })

    if (!response.ok) {
        throw new Error('Something went wrong!, please try again');
    }

    return response;
}

InvoiceService.removeInvoice = async invoiceId => {

    const response = await fetch(`${REMOVE_INVOICE_API_URL}/${invoiceId}`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${storageUtils.getToken()}`,
            'role': storageUtils.getRole()
        }
    });

    if (!response.ok) {
        throw new Error('Something went wrong!, please try again');
    }

    return response;

}

InvoiceService.UpdateInvoiceWeight = async (invoiceId, weight) => {

    const response = await fetch(`${UPDATE_INVOICE_WEIGHT_API_URL}/${invoiceId}`, {
        method: 'POST',
        headers: {
            'Content-type':'application/json',
            'Authorization': `Bearer ${storageUtils.getToken()}`,
            'role': storageUtils.getRole()
        },
        body:JSON.stringify({weight:weight})
    });
    if (!response.ok) {
        throw new Error('Something went wrong!, please try again');
    }

    return response;

}

export default InvoiceService;